<template>
  <div class="container-privacy-joylink" :style="`paddingTop:${barHeight}px`">
    <div class="main">
      <div class="title">Privacy Policy</div>
      <div class="tit">1. Introduction</div>
      <div>
        This JoyLink Privacy Policy explains how JoyLink (“JoyLink”, “we”, or”us”) process any personal data we collect from visitors and users of www.joylink.live and any
        applications, services provided in relation to the website (collectively, the “Services”).
      </div>
      <div>
        We is committed to protecting your privacy rights and making our practices regarding processing of Personal Information (as defined below) more transparent and fair.
      </div>
      <div>
        This Privacy Policy (“Policy” ) was designed to help you understand the information we collect, store, use and share, and it applies whenever you visit our Website, our App
        or otherwise use or access our Services.
      </div>
      <div>
        You are not legally required to provide us with any Personal Information, but without it we will not be able to provide you with the full range or with the best experience
        of using our Services. We strongly urge you to read this Policy and make sure that you fully understand and agree to it. By using the Services, including our Website or
        App, you signify your acceptance of this Policy. If you do not agree to the terms of this Policy, please do not use our Services. Your continued use of the Services
        following the posting of changes to this Policy will mean that you accept such changes.
      </div>
      <div class="tit">2.What Types of Data We Collect?</div>
      <div>
        We collect two types of data from you: personal information ( "Personal Information") and non-Personal Information. Personal Information means any information which may
        potentially allow your identification with reasonable means (for example, email address or name). Non-Personal Information, by contrast, can be defined as any information
        that does not relate to an identified or identifiable natural person. This may include, for example, your aggregated usage information and technical information transmitted
        by your device (for example, the device you use, the type of browser and operating system your device uses, language preference, access time, etc.). This section sets out
        how and when we collect those types of data from you.
      </div>
      <div class="tit-tow">2.1 Personal information.</div>
      <div class="passage">
        Registration Information. During your registration to the Services we request certain personal information from you, including your name, email address, social media
        identifiers and your contacts details.
      </div>
      <div class="passage">
        Device identifiers and device data. When you visit or access the Services, we also collect your IP address, UDID, your precise geolocation and other information transmitted
        by your device, including among other things the type of browser and operating system your device uses.
      </div>
      <div class="passage">
        Log-in history and usage information. In order to enhance the functionality of the Services and to provide you with a better user experience, we collect technical
        information transmitted by your device when you use the Services, including information related to your behavior and use of the Services.
      </div>
      <div class="passage">
        Location information. The Company collects information about your general location (such as city and country). For example, we may use the IP address to identify your
        general location. This information does not tell us where your device is precisely located. This information is sent as a normal part of internet traffic. In addition, we
        also collect implicit location information, which allows us to infer that you are either interested in a place or that you might be at the place – this information does not
        actually tell us where your device is precisely located. In addition, the Company collects the precise location of your device (using GPS signals, device sensors, Wi-Fi
        access points, Bluetooth signals, Beacons signals and cell tower ids that can be used to derive or estimate precise location, or other geo-location data), when location
        services have been enabled by the end user (you typically have to choose to turn on device-based location services).
      </div>
      <div class="passage">
        Communication Information. When you send us an email or contact us via the support in our Services, we collect the Personal Information you provide us. This may include
        your name, email address and any other information you choose to provide.
      </div>
      <div class="tit-tow">2.2 Non Personal Information.</div>
      <div class="passage">
        We process, use or share non-Personal Information, aggregated information or Personal Information in non-human readable form (e.g. anonymous or aggregated information
        concerning the way our user community interacts with the Services) in any of the above circumstances, as well as for the purpose of providing and improving our Services,
        aggregate statistics, marketing purposes and conduct business and marketing analysis, and enhance your experience with the Service.
      </div>
      <div class="passage">
        We may anonymize or de-identify the information collected by the Services or via other means so that the information cannot, on its own, personally identify you. Our use
        and disclosure of such aggregated or de-identified information is not subject to any restrictions under this Policy, and we may disclose it to others without limitation and
        for any purpose, such as for advertising or marketing purposes.
      </div>
      <div class="passage">
        If we combine Personal Information with Anonymous Information, the combined information will be treated as Personal Information for as long as it remains combined.
      </div>
      <div class="tit">3.Tracking Technologies</div>
      <div>
        When you visit or access our Services, we use cookies, pixels, beacons, local storage and similar technologies ( "Tracking Technologies"). These allow us to automatically
        collect information about you, your device, and your online behavior, in order to enhance your navigation in our Services, improve our Service's performance, perform
        analytics, customize your experience and offer you, for example, tailored content and advertisements that better correspond with your interests.
      </div>
      <div class="tit-tow">3.1What types of Tracking Technologies do we use?</div>
      <div class="passage">
        Strictly Necessary Tracking Technologies – these Tracking Technologies are automatically placed on your computer or device when you access our Services or take certain
        actions on our App or Website. These Tracking Technologies are essential to enable you to navigate around and use the features of our Services. We do not need to obtain
        your consent in order to use these Tracking Technologies;
      </div>
      <div class="passage">
        Tracking and Advertising Tracking Technologies – these Tracking Technologies collect information about your browsing habits in order to make advertising more relevant to
        you and your interests. They are also used to limit the number of times you see an advertisement as well as help measure the effectiveness of an advertising campaign. The
        Tracking Technologies remember the websites you visit and that information is shared with other parties such as advertisers and/or publishers. Publishers, advertisers, and
        third-party ad networks may also utilize Tracking Technologies or similar technologies to deliver ads and monitor the performance of such ads. The collection of information
        through Tracking Technologies by such third parties will be governed by their own privacy policies/cookies policies and principles, which the Company does not control;
        Functionality Tracking Technologies – these Tracking Technologies allow our Services to remember choices you make (such as your language) and provide enhanced and
        personalized features. For example, these Tracking Technologies are used for authentication (to remember when you are logged-in) and support other features of our Services;
      </div>
      <div class="passage">
        Performance Tracking Technologies – these Tracking Technologies collect information about your online activity (for example the duration of your visit on our Services),
        including behavioural data and content engagement metrics. These Tracking Technologies are used for analytics, research and to perform statistics (based on aggregated
        information).
      </div>
      <div class="tit-tow">3.2 How and by whom Tracking Technologies are stored on your device?</div>
      <div class="passage">
        We store Tracking Technologies on your device when you visit or access our Services (for example, when you are visiting our Website) – these are called "First Party
        Tracking Technologies". In addition, Tracking Technologies are stored by other third parties (for example, our analytics service providers, business partners, and
        advertisers), who run content on our Services – these are called "Third Party Tracking Technologies". Both types of Tracking Technologies may be stored either for the
        duration of your visit on our Services or for repeat visits.
      </div>
      <div class="passage">
        There are various ways in which you can manage and control your Tracking Technologies settings. You can change your preferences using our cookie settings tool (however,
        please note that this tool may only be available in certain jurisdictions). Other methods of managing your Tracking Technology preferences includes: changing your browser
        settings to send a “Do-Not-Track” signal. In such case, your browser will send us a special signal to stop tracking your activity; However, please note that certain
        features of the Website may not work properly or effectively if you delete or disable cookies.
      </div>
      <div class="passage">
        You can withdraw your consent to personalized advertising experience on your device at any time by using your device settings as follows:
        <div>
          - On iOS, depending on the applicable iOS version, you may withdraw consent across all apps by either enabling the “Limit Ad Tracking” setting or disabling the “Allow
          Apps to Request to Track” permission in your iOS device settings. Depending on the applicable iOS version, instead of withdrawing consent on a device-wide basis, you may
          also have the option of withdrawing consent on a per-app basis by disabling tracking permissions for specific apps that appear under the “Allow Apps to Request to Track”
          setting in your iOS device settings (precise directions may differ depending on the applicable iOS version).
        </div>
      </div>

      <div class="tit">4.Data Sharing</div>
      <div>
        We do not rent, sell, or share your Personal Information with third parties (“Recipients”) except as described in this Privacy Policy. The Personal Information will be
        disclosed to Recipients only to the extent required for the specific purpose, as stipulated in this Privacy Policy. We share Personal Information with any of the following
        recipients:
      </div>
      <div>Any service provider that we engage with to operate the Service;</div>
      <div>Our affiliated companies;</div>
      <div>
        Subcontractors and third party service providers, as well as their subcontractors, which by way of example include (but is not limited to) cloud computing companies,
        marketing affiliates, fraud prevention services, and other data verifiers;
      </div>
      <div>Payment service providers and payment processors;</div>
      <div>Auditors, contractors or legal/financial/other advisers of any of our business processes;</div>
      <div>
        Any third parties who investigate, detect or prevent fraudulent or illegal activity or enable us to enforce our policies, including in order to ascertain your source of
        income or funds (e.g. governmental authorities, law enforcement bodies, banks and other investigatory bodies);
      </div>
      <div>Governmental and regulatory bodies, in accordance with applicable laws and regulations;</div>
      <div>
        Potential purchasers, successors or investors in any of the companies within our group companies, or in the event of a corporate transaction (e.g. sale of a substantial
        part of our business, merger, reorganization, bankruptcy, consolidation or asset sale of an asset or transfer in the operation thereof) in relation to any company within
        our group companies (in such event, the acquiring company or transferee will assume the rights and obligations as described in this Policy).
      </div>

      <div class="tit">5.International Data Transfers</div>
      <div>
        We may transfer or disclose Personal Information to our subsidiaries, affiliated companies, subcontractors or such other trusted third party service providers or partners,
        who are located in different jurisdictions across the world for the purpose described in this Policy. Information collected by Company may be stored and processed in any
        jurisdiction where Company or its affiliates, subsidiaries, partners, or service providers are located or maintain facilities.
      </div>
      <div>
        If we provide any information about you to any such entities, we will take appropriate measures to ensure such companies protect your information adequately in accordance
        with this Policy and applicable law.
      </div>

      <div class="tit">6.Third party collection of information</div>
      <div>
        Our policy only addresses the use and disclosure of information we collect from you. To the extent that you disclose your information to other parties on our Services or
        other sites throughout the internet, different rules may apply to their use or disclosure of the information you disclose to them. For example, when making a payment by
        credit card our third party processors such as the Apple Store, they may collect your credit card information and other information necessary for processing/authorizing
        your credit card payments. These payment companies may also provide certain of your details to us.
      </div>
      <div>
        This Policy does not apply to the practices of companies that we do not own or control, or to individuals whom we do not employ or manage, including any of the third
        parties to which we may disclose information as set forth in this Policy. The Services may also enable you to interact (whether directly or through link) with third party
        websites, mobile software applications and services that are not owned or controlled by us (each a "Third Party Services(s)"). We are not responsible for the privacy
        practices or the content of any Third Party Services. Please be aware that the Third Party Services may collect Personal Information from you. Accordingly, we encourage you
        to read the terms and conditions and privacy policy of each Third Party Service that you choose to use or interact with.
      </div>
      <div>
        You are knowingly and voluntarily assuming all risks of using any Third Party Services. You agree that we shall have no liability whatsoever with respect to such Third
        Party Services and your usage of them.
      </div>

      <div class="tit">7.Children’s Privacy</div>
      <div>
        The Services are not directed at children under the age of consent (namely, below the age where consent must be given or authorized by the holder of parental responsibility
        over the child, as required under the applicable law in the jurisdiction you reside in ( “Age of Consent”)). If you are under the Age of Consent you may use the Services
        only if consent is given or authorized by the holder of parental responsibility.
      </div>
      <div>
        If Company learns that Personal Information of persons under the Age of Consent has been collected on or through the Services without parental or guardian consent, Company
        will take appropriate steps to delete this information unless it is needed to comply with any legal or statutory obligation.
      </div>

      <div class="tit">8.Retention of Personal Information</div>
      <div>
        If you have registered with an account through our Services, the Company will retain your Personal Information during the period your account is active. In addition, the
        Company will retain your Personal Information for additional periods, to enable the Company to meet its legal obligations, e.g. Know-Your-Customer and Anti-Money Laundering
        requirements.
      </div>
      <div>
        In addition, the Company may retain your Personal Information for longer periods, provided that retaining such information is necessary for the Company’s legitimate
        interests, such as fraud prevention and record keeping.
      </div>

      <div class="tit">9.What are Your Rights?</div>
      <div>
        If you reside in the EU or in other locations that provide you with the below rights, you may contact us at any time by email (at: joylink827@gmail.com) and request:
      </div>
      <div>1. To access or delete any Personal Information relating to you;</div>
      <div>
        2. To change or update any Personal Information relating to you (for example, if you believe that your Personal Information is incorrect, you may ask to have it corrected
        or deleted). Note that you may also request that we will correct errors with regard to your Personal Information (except in cases where the information is required to be
        kept in its original format under any applicable laws and regulations);
      </div>
      <div>3. That we will restrict any further use of your Personal Information;</div>
      <div>4. That we will provide the Personal Information you volunteered to us in a machine-readable format;</div>
      <div>5. To object to the processing your Personal Information (such as for marketing purposes);</div>
      <div>6. To withdraw your consent to our processing activities (provided that such processing activities rely on your consent, and not on a different legal basis);</div>
      <div>
        7. Not to be subject to a decision based solely on automated processing, including profiling, which produces legal effects concerning you or similarly significant affects
        you, except where such processing is necessary for the performance of the contract between you and us, or it is based on your explicit consent, as provided hereunder.
      </div>
      <div>
        Please note that these rights are not absolute and requests are subject to any applicable legal requirements, including any legal and ethical reporting or document
        retention obligations. We may also rectify, replenish or remove incomplete or inaccurate information, at any time and at our own discretion, in accordance with our internal
        policies.
      </div>
      <div>If you are unsatisfied with our response, you can reach out to the applicable data protection supervisory authority.</div>

      <div class="tit">10.How to delete your information?</div>
      <div>
        If you have an Apple device, you can request to delete your data by clicking on your Me > Settings > Account Settings > Delete Account ( "Account Deletion Request").
      </div>
      <div>
        When you submit an Account Deletion Request, we delete the content you have posted, streamed or created, and you won't be able to recover that information later.
        Information that others have shared about you isn't part of your account and won't be deleted.
      </div>
      <div>
        Please note that all Account Deletion Requests are subject to our retention policy, and the Company reserves the right to retain certain Personal Information for the
        purpose of meeting its legal obligations, for fraud prevention and for record keeping purposes.
      </div>
      <div class="tit-tow">10.1 Registered users.</div>
      <div class="passage">
        All Account Deletion Requests of registered users will be processed within thirty (30) days period ( "Processing Period"). You can reactivated your user within the
        Processing Period. After the Processing Period will end, you will no longer we able to access your account and the Company will remove all Personal Information related to
        your account.
      </div>
      <div class="tit-tow">10.2 Guests.</div>
      <div class="passage">All Account Deletion Requests of guest users will be processed promptly, and all Personal Information collected on the guest user will be deleted.</div>

      <div class="tit">11.How we keep your information secured</div>
      <div>
        We take great care in implementing and maintaining the security of the Services and your information. We have put in place appropriate physical and technological safeguards
        to help prevent unauthorized access, to maintain data security, and to use correctly the information we collect online. These safeguards vary based on the sensitivity of
        the information that we collect and store.
      </div>
      <div>
        Although we take reasonable steps to safeguard information, we cannot be responsible for the acts of those who gain unauthorized access or abuse the Services, and we make
        no warranty, express, implied or otherwise, that we will prevent such access.
      </div>

      <div class="tit">12.Changes to the Privacy Policy</div>
      <div>
        We reserve the right to change this Policy at any time, so please re-visit this page frequently. We will provide notice of substantial changes of this Policy on our
        Services and/or we will send you an e-mail regarding such changes to the applicable e-mail address that you provided to us. Such substantial changes will take effect
        fourteen (14) days after such notice was provided on any of the above mentioned methods. Otherwise, all other changes to this Policy are effective as of the stated “Last
        Revised” date, and your continued use of our Services after the Last Revised date will constitute acceptance of, and agreement to be bound by, those changes.
      </div>

      <div class="tit">13.How to contact us?</div>
      <div>
        If you have any general questions about the Services or the information that we collect about you and how we use it, please contact us via email at joylink827@gmail.com.
      </div>
      <div>We will make an effort to reply within a reasonable timeframe. Please feel free to reach out to us at any time.</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.container-privacy-joylink {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  line-height: 36px;

  .main {
    padding: 16px;
    color: #666666;
    font-size: 24px;
    .title {
      width: 100%;
      margin-bottom: 16px;
      text-align: center;
      font-size: 32px;
      color: #333;
      font-weight: bold;
    }
    .head {
      text-indent: 2em;
    }
    .tit {
      font-weight: 700;
      color: #333333;
      margin: 16px 0 8px 0;
      font-size: 28px;
    }
    .tit-tow {
      color: #333333;
      font-weight: 600;
      margin-top: 8px;
    }
    .passage {
      margin-top: 8px;
    }
  }
}
@media screen and (max-width: 767px) {
  .container-privacy-joylink {
    width: 100%;
    min-height: 100vh;
    background: #ffffff;
    line-height: 18px;

    .main {
      padding: 16px;
      color: #666666;
      font-size: 12px;
      .title {
        width: 100%;
        margin-bottom: 16px;
        text-align: center;
        font-size: 16px;
        color: #333;
        font-weight: bold;
      }
      .head {
        text-indent: 2em;
      }
      .tit {
        font-weight: 700;
        color: #333333;
        margin: 16px 0 8px 0;
        font-size: 14px;
      }
      .tit-tow {
        color: #333333;
        font-weight: 600;
        margin-top: 8px;
      }
      .passage {
        margin-top: 8px;
      }
    }
  }
}
</style>
